export const globalThrottleMap = new Map();

export const clearGlobalThrottleMap = () => {
  globalThrottleMap.clear();
};
